import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-process-template.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import './process-template.css';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import { IWeightedProductFilter } from '../../models/IWeightedProductFilter';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import { formatMessage } from '../../translations/format-message';
// import AddProcess from './components/add-edit-process-template';
// import FilterComponent from './components/filter';
// import AddProcessPopupHOC from './hoc/add-process-templ-popup-hoc';
import AddProcessTemplatePopupHOC from './hoc/add-process-template-popup-hoc';
// import './process.css';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Header from '../../shared-components/header/header';
import { PlusIcon } from '../../shared-components/svgs/svgs';
import AddEditProcessTemplate from './components/add-edit-process-template';
import ProcessTemplateDetails from './process-template-details';

const ProcessTemplate = (props: any) => {
  const { preferencesStore, processTemplateStore } = useStore();
  const {
    GetProcessTemplateListService,
    allProcessTemplate,
    processTemplateList,
    deleteProcessTemplateState,
    DeleteProcessTemplateService,
    resetDeleteProcessTemplate,
    resetProcessTemplateDetail,
    addUpdateProcessTemplateState,
    resetAddUpdateProcessTemplateState,
    GetProcessTemplateByIdService,
    processTemplateDetails,
    processTemplateState,
    getAllProcessTemplateState,
  } = processTemplateStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allProcessTemplateListData = allProcessTemplate;

  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [filterObj, setFilterObj] = useState<IWeightedProductFilter>({
    TenantId: -1,
    ProductName: '',
    Sku: '',
    ColumnOrder: '',
    StartDate: '',
    EndDate: '',
  });
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessTemplateListServiceHandler = () => {
    GetProcessTemplateListService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit
    );
  };

  useEffect(() => {
    getProcessTemplateListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: processTemplateList?.PagingDetails?.CurrentPage,
      totalPages: processTemplateList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [processTemplateList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessTemplateListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessTemplateListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (language !== lang) {
      getProcessTemplateListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateProcessTemplateState.success) {
      resetAddUpdateProcessTemplateState();
      getProcessTemplateListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateProcessTemplateState.success]);

  useEffect(() => {
    if (deleteProcessTemplateState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteProcessTemplate();
      getProcessTemplateListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteProcessTemplateState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessTemplateListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteProcessTemplateService(
      Number(getTenantIdFromLocalStorage()),
      selectedId
    );
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProcessTemplateDetail();
    props.deletePopupToggleHandler();
  };

  const openAddProcessTemplateHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetProcessTemplateDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  function formatDate(date: Date) {
    const day = date.getDate(); // 13
    const month = date.getMonth(); // 11 (months are 0-indexed, so add 1)
    const year = date.getFullYear(); // 2024
    return new Date(year, month, day);
  }

  const filterHandler = (filter: string) => {
    // getProductListServiceHandler("added_date DESC", encodeURIComponent(filter));
    // setFilterString(encodeURIComponent(filter));
    // closePanelhandler();
    // props.filterPopupToggleHandler();
    // setIsFilterCleared(false);
  };

  const filterParams = (
    obj: IWeightedProductFilter,
    isfilterCleard: boolean
  ) => {
    // if (isfilterCleard) {
    //   setFilterObj({
    //     ...obj,
    //     EndDate: null,
    //     StartDate: null,
    //     ColumnOrder: `${getFieldName(sortColumn)}  ${sortOrder}`,
    //     TenantId: -1,
    //   });
    //   getProductListServiceHandler("added_date DESC");
    //   closePanelhandler();
    //   setIsFilterCleared(true);
    //   setFilterString("");
    // } else {
    //   setFilterObj({
    //     ...obj,
    //     ColumnOrder: `${getFieldName(sortColumn)}  ${sortOrder}`,
    //     TenantId:
    //       getTenantIdFromLocalStorage() === "-1"
    //         ? Number(selectedTenantId)
    //         : Number(getTenantIdFromLocalStorage()),
    //   });
    // }
    props.filterPopupToggleHandler();
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddProcessTemplateHandler,
        icon: (
          <svg
            id="Layer_2"
            fill="#0091ff"
            width="21"
            height="21"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28.43 24.75"
          >
            <g
              id="_レイヤー_3"
              data-name="レイヤー 3"
            >
              <g>
                <path d="M10.53,15.53l1.19,1.19,1.19,1.19-1.85,.58-1.61,.5,.5-1.61,.58-1.85m-.45-1.81l-1.05,3.37-1.05,3.37,3.37-1.05,3.37-1.05-2.32-2.32-2.32-2.32h0Z" />
                <polygon points="7.97 20.46 8.57 18.54 9.17 16.62 10.49 17.94 11.81 19.26 9.89 19.86 7.97 20.46" />
                <path d="M15.22,19.37l-6.15-6.15L22.28,0l6.15,6.15-13.21,13.21Zm-3.12-6.15l3.12,3.12L25.4,6.15l-3.12-3.12L12.1,13.21Z" />
                <path d="M23.57,24.75H4.47c-2.46,0-4.47-2-4.47-4.47v-6.38c0-2.46,2-4.47,4.47-4.47h2.36v2.24h-2.36c-1.23,0-2.23,1-2.23,2.23v6.38c0,1.23,1,2.23,2.23,2.23H23.57c1.23,0,2.23-1,2.23-2.23v-7.47h2.24v7.47c0,2.46-2,4.47-4.47,4.47Z" />
                <rect
                  x="13.01"
                  y="8.8"
                  width="11.25"
                  height="1.3"
                  transform="translate(-1.22 15.95) rotate(-45)"
                />
              </g>
            </g>
          </svg>
        ),
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProcessTemplateManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: (
          <svg
            id="Layer_2"
            fill="#0091ff"
            width="18"
            height="18"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20.09 20.66"
          >
            <g
              id="_レイヤー_3"
              data-name="レイヤー 3"
            >
              <g>
                <polygon points="12.12 1.99 12.12 0 10.05 0 7.97 0 7.97 1.99 0 1.99 0 4.07 10.05 4.07 20.09 4.07 20.09 1.99 12.12 1.99" />
                <path d="M14.29,17.76c-.02,.37-.32,.66-.69,.66H6.49c-.37,0-.67-.29-.69-.65l-.53-12.44-2.24,.09,.53,12.45c.08,1.56,1.37,2.78,2.93,2.78h7.11c1.56,0,2.85-1.22,2.93-2.79l.53-12.44-2.24-.09-.53,12.43Z" />
                <rect
                  x="11.68"
                  y="6.8"
                  width="1.16"
                  height="9.8"
                />
              </g>
            </g>
          </svg>
        ),
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProcessTemplateManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.ProcessTemplateManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'TemplateName',
      text: formatMessage('template_name'),
      classes: 'show-Elipses',
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
      // sort: true,
      // onSort: (field: string, order: 'asc' | 'desc') => {
      //   // Call your handler function with the order value
      //   setSortField(field);
      //   setSortOrder(order);
      //   getProcessListServiceHandler();
      // }
    },
    {
      dataField: 'Remarks',
      text: formatMessage('process_template_remarks'),
      classes: 'show-Elipses',
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  return (
    <>
      {props.showAddProcessTemplatePopup && (
        <AddEditProcessTemplate
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_process_template"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_process_template_confirm"
          isLoading={deleteProcessTemplateState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header className='col-lg-6 col-md-6 col-sm-6' label="process_template_title" />
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                {/* <FilterComponent
                  initialValues={{
                    StartDate:
                      filterObj.StartDate === null || filterObj.StartDate === ''
                        ? ''
                        : formatDate(new Date(filterObj.StartDate)),
                    EndDate:
                      filterObj.EndDate === null || filterObj.EndDate === ''
                        ? ''
                        : formatDate(new Date(filterObj.EndDate)),
                    Name: filterObj.ProductName,
                    Sku: filterObj.Sku.length > 0 ? filterObj.Sku.replace(/'/g, '').split(',').join(',') : '',
                  }}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={
                    false
                    // getTenantIdFromLocalStorage() === "-1" &&
                    // selectedTenantId === -1
                  }
                  isFilterCleared={false} // isFilterCleared={isFilterCleared}
                /> */}
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <svg
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-repeat m-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path
                      fillRule="evenodd"
                      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                    />
                  </svg>
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.ProcessTemplateManagement,
                'Add'
              ) && (
                <li title={formatMessage('add_process_template')}>
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddProcessTemplateHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      {' '}
                      <PlusIcon />
                    </span>
                    <FormattedMessage id="add_process_template" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllProcessTemplateState.inProgress ||
            processTemplateState.inProgress ||
            deleteProcessTemplateState.inProgress) && (
            <FormLoader
              loading={
                getAllProcessTemplateState.inProgress ||
                processTemplateState.inProgress ||
                deleteProcessTemplateState.inProgress
              }
            />
          )}
          {allProcessTemplateListData &&
          allProcessTemplateListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allProcessTemplateListData && (
                      <Grid
                        data={allProcessTemplateListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        // sort={{dataField: 'ProcessName', order: sortOrder}}
                        // remote = {{sort: true}}
                        // onTableChange={onTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessTemplateListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={processTemplateList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_process_template" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_process_template_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.ProcessTemplateManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddProcessTemplateHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        <FormattedMessage id="add_process_template" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.TemplateName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <svg
                  onClick={closePanelHandler}
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x ms-auto d-block"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <ProcessTemplateDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddProcessTemplatePopupHOC(DeletePopupHOC(observer(ProcessTemplate)))
);
